// Shared furniture for the playable modes: the header strip, the result card,
// and the tiny helpers each mode would otherwise reinvent.

export function modeShell(root, { id, name, kicker }) {
  root.innerHTML = `<div class="mode-screen mode-${id}">
    <header class="mode-bar">
      <div class="mode-id"><span class="mode-pip"></span><b>${name}</b><small>${kicker}</small></div>
      <div class="mode-readout" data-role="readout"></div>
      <button class="mode-exit" data-role="exit">ABORT / BOOK OUT</button>
    </header>
    <div class="mode-body" data-role="body"></div>
  </div>`;
  return {
    body: root.querySelector('[data-role="body"]'),
    readout: root.querySelector('[data-role="readout"]'),
    exit: root.querySelector('[data-role="exit"]'),
  };
}

export function readoutMarkup(cells) {
  return cells.map(([label, value, tone = '']) => `<span class="mode-stat ${tone}"><small>${label}</small><b>${value}</b></span>`).join('');
}

// Every mode settles into the same currency: seconds of your standing output.
// That keeps rewards meaningful at any point in the run without a mode ever
// minting a number that outruns the main economy.
export function resultCard(body, { title, lines, seconds, glimmer, best }) {
  body.innerHTML = `<div class="mode-result">
    <span class="eyebrow">AFTER ACTION REVIEW</span>
    <h2>${title}</h2>
    <div class="result-lines">${lines.map(([label, value]) => `<div><span>${label}</span><strong>${value}</strong></div>`).join('')}</div>
    <div class="result-payout">
      <div><small>PAYOUT</small><b>${Math.round(seconds)}s OF OUTPUT</b></div>
      <div><small>GLIMMER</small><b>+${glimmer}</b></div>
      ${best !== undefined ? `<div><small>PERSONAL BEST</small><b>${best}</b></div>` : ''}
    </div>
    <div class="result-actions">
      <button class="mode-again" data-role="again">RUN IT AGAIN</button>
      <button class="mode-done" data-role="done">RETURN TO WATCH</button>
    </div>
  </div>`;
}

export function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }

export function formatClock(ms) {
  const total = Math.max(0, Math.ceil(ms / 1000));
  return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
}
